/**
 * Extract a human-readable error message from an axios error.
 *
 * FastAPI returns three different shapes for `detail`:
 *   - A plain string (HTTPException raised by us)
 *   - An array of objects (Pydantic validation errors: 422)
 *   - An object (rare, custom HTTPException with structured detail)
 *
 * Without normalization, React would render "[object Object]" in toasts.
 */
export function extractApiError(err, fallback = "Errore sconosciuto") {
  const detail = err?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }
  if (Array.isArray(detail)) {
    // Pydantic validation error: [{loc, msg, type}, ...]
    const msgs = detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (d && typeof d === "object" && typeof d.msg === "string") return d.msg;
        return null;
      })
      .filter(Boolean);
    if (msgs.length) return msgs.join("; ");
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    try { return JSON.stringify(detail); } catch { /* fallthrough */ }
  }

  return err?.message || fallback;
}
